/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_Check_In_SuccessInputs */

const en_verify_check_in_success = /** @type {(inputs: Verify_Check_In_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✅ Guest successfully checked in!`)
};

const es_verify_check_in_success = /** @type {(inputs: Verify_Check_In_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✅ ¡Invitado registrado con éxito!`)
};

const fr_verify_check_in_success = /** @type {(inputs: Verify_Check_In_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✅ Invité enregistré avec succès !`)
};

const de_verify_check_in_success = /** @type {(inputs: Verify_Check_In_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✅ Gast erfolgreich eingecheckt!`)
};

const id_verify_check_in_success = /** @type {(inputs: Verify_Check_In_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✅ Tamu berhasil check-in!`)
};

/** @type {(inputs: Verify_Check_In_SuccessInputs) => LocalizedString} */
const ja_verify_check_in_success = en_verify_check_in_success;

/** @type {(inputs: Verify_Check_In_SuccessInputs) => LocalizedString} */
const zh_verify_check_in_success = en_verify_check_in_success;

/** @type {(inputs: Verify_Check_In_SuccessInputs) => LocalizedString} */
const ar_verify_check_in_success = en_verify_check_in_success;

/** @type {(inputs: Verify_Check_In_SuccessInputs) => LocalizedString} */
const it_verify_check_in_success = en_verify_check_in_success;

/** @type {(inputs: Verify_Check_In_SuccessInputs) => LocalizedString} */
const ru_verify_check_in_success = en_verify_check_in_success;

/** @type {(inputs: Verify_Check_In_SuccessInputs) => LocalizedString} */
const pt_verify_check_in_success = en_verify_check_in_success;

/** @type {(inputs: Verify_Check_In_SuccessInputs) => LocalizedString} */
const ko_verify_check_in_success = en_verify_check_in_success;

/**
* | output |
* | --- |
* | "✅ Guest successfully checked in!" |
*
* @param {Verify_Check_In_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verify_check_in_success = /** @type {((inputs?: Verify_Check_In_SuccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_Check_In_SuccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verify_check_in_success(inputs)
	if (locale === "es") return es_verify_check_in_success(inputs)
	if (locale === "fr") return fr_verify_check_in_success(inputs)
	if (locale === "de") return de_verify_check_in_success(inputs)
	if (locale === "ja") return ja_verify_check_in_success(inputs)
	if (locale === "zh") return zh_verify_check_in_success(inputs)
	if (locale === "ar") return ar_verify_check_in_success(inputs)
	if (locale === "id") return id_verify_check_in_success(inputs)
	if (locale === "it") return it_verify_check_in_success(inputs)
	if (locale === "ru") return ru_verify_check_in_success(inputs)
	if (locale === "pt") return pt_verify_check_in_success(inputs)
	return ko_verify_check_in_success(inputs)
});